import React from 'react'
import Banner from '../elements/Banner'
import ProfilePicture from '../elements/ProfilePicture'
import BusinessName from '../elements/BusinessName'
import Social from '../components/Social'
import About from '../elements/About'
import SaveAsContact from '../components/SaveAsContact'
import Accordions from '../components/Accordions'
import ImageSwiper from '../elements/ImageSwiper'
import ClientsSwiper from '../elements/ClientsSwiper'
import CallToAction from '../elements/CallToAction'
import Share from '../elements/Share'
import Title from '../elements/Title'
import Line from '../elements/Line'
// Import your image with the correct file path
import ImageSwiperCloser from '../elements/ImageSwiperCloser'

import { bgImageSrc, bannerImageSrc, logoImageSrc, images, products } from '../media'

import PriceList from '../images/priceList.jpeg'
import LogoReal from '../images/logoImage.png'
import ProductsSwiper from '../elements/ProductsSwiper'

const HomePage = () => {
  const divStyle = {
    backgroundImage: `url(${bgImageSrc})`, // Note the closing parenthesis
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  }
  console.log('products:', products)

  const pilatesProducts = [
    {
      headline: 'הסרת שיער בלייזר לנשים',
      info: 'טיפול מתקדם ויעיל להסרת שיער באזורים שונים בגוף, כולל רגליים, בית שחי ומפשעות.',
      image: products[0],
    },
    {
      headline: 'הסרת שיער בלייזר לגברים',
      info: 'טיפול להסרת שיער לגברים, מתאים לאזורים כמו גב, חזה וצוואר, עם תוצאות ארוכות טווח.',
      image: products[1],
    },
    {
      headline: 'הסרת שיער בלייזר באזורים אינטימיים - ע"י אחות',
      info: 'טיפול דיסקרטי ומקצועי להסרת שיער באזורים רגישים, מבוצע על ידי אחות מוסמכת.',
      image: products[2],
    },
    {
      headline: 'מניקור',
      info: 'טיפוח ציפורניים ועור כפות הידיים, כולל שיוף, עיצוב ומריחת לק איכותי.',
      image: products[3],
    },
    {
      headline: "לק ג'ל",
      info: "מריחת לק ג'ל עמיד בצבעים אופנתיים עם תוצאה מבריקה המחזיקה לאורך זמן.",
      image: products[4],
    },
    {
      headline: 'פדיקור רפואי',
      info: 'פדיקור רפואי וטיפול בציפורן חודרנית , טיפול בפטרת ציפורנים וכף הרגל',
      image: products[5],
    },
    {
      headline: 'עיצוב גבות טבעיות',
      info: 'עיצוב עדין ומחמיא לשמירה על מראה טבעי של הגבות, ללא שינוי דרמטי.',
      image: products[6],
    },
    {
      headline: 'איפור קבוע',
      info: 'טיפול קוסמטי הכולל החדרת פיגמנט לעור ליצירת מראה מאופר קבוע לאורך זמן.',
      image: products[7],
    },
    {
      headline: 'שזירת ריסים קרה',
      info: 'הארכת ריסים באמצעות הדבקה עדינה, ללא חום, למראה טבעי ומרשים.',
      image: products[8],
    },
    {
      headline: 'שיזוף בהתזה',
      info: 'טיפול שיזוף בגוון אחיד וללא קרינה באמצעות התזת חומר שיזוף איכותי.',
      image: products[9],
    },
    {
      headline: 'החלקת שיער אורגנית',
      info: 'אחריות מלאה על ההחלקה, התחייבות לתוצאה 100% מושלמת, באישור משרד הבריאות',
      image: products[10],
    },
    {
      headline: 'עיסוי רפואי לנשים בלבד',
      info: 'עיסוי קלאסי / רפואי / לימפטי / כוסות רוח',
      image: products[11],
    },
  ]

  return (
    <div className="bg-gray-100">
      <div className="bg-white w-full md:w-5/6 lg:w-3/4 mx-auto shadow-2xl rounded-2xl  ">
        <div style={divStyle}>
          <Banner type="rectangle" image={bannerImageSrc} />

          <ProfilePicture type="circle" image={logoImageSrc} />

          <BusinessName businessName="דפנה כהן" businessDescription="עיצוב פנים" />

          <div className="my-4 p-1 bg-transparent"></div>
          <Social
            phoneNumber="+972528798447"
            phoneText="חייגו אליי"
            whatsappNumber="+972528798447"
            facebookUrl="https://www.facebook.com/dafnadesigen"
            locationUrl="https://maps.app.goo.gl/Wm8Gy6krPUH4T8dJ9"
            wazeUrl=""
            wazeText="נווטו לקליניקה"
            instagramUsername="dafna.cohen.designer"
            tiktokUsername=""
            type="circleBorder"
            email="d@dafnac.co.il"
            shareButton={false} // ✅ Share button enabled
          />

          {/* <div className=" max-w-[300px] mx-auto my-4 animate-pulse duration-1000">
            <a
              href="https://n1220649.alteg.io/"
              target="_blank"
              rel="noopener noreferrer"
              className="group hover:shadow-2xl border-4 black-bg shadow-xl   hover:shadow-[#f5cec8]/60 transition ease-in-out  p-1 rounded-xl bg-gradient-to-br from-[#000] via-[#333] to-[#000] hover:from-[#333] hover:via-[#000] hover:to-[#333] max-w-[300px] mx-auto flex flex-col justify-around items-center text-center  border-white dir-rtl"
            >
              <div className="px-6 py-2 w-full backdrop-blur-xl   rounded-xl font-bold h-full">
                <span className="block mb-1 font-light text-2xl pink-rose-text hover:underline">
                  לקביעת תור דרך האפליקציה לחצו כאן
                </span>
                <span className="block text-lg mb-1 font-semibold gold-text">VITALIA BEAUTY</span>
                <svg
                  className="w-6 h-6 stroke-yellow-200 group-hover:stroke-[#fecef6]"
                  strokeWidth="1.8"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
                    strokeLinejoin="round"
                    strokeLinecap="round"
                  ></path>
                </svg>
              </div>
            </a>
          </div> */}
          <SaveAsContact
            text="שמרו אותי כאיש קשר  "
            phoneNumber="+972528798447"
            email="d@dafnac.co.il"
            firstName="דפנה כהן"
            lastName="עיצוב פנים"
            type="rectangle"
          />

          <About />

          {/* <div className='max-w-[500px] p-8 mx-auto'>
                        <img className=' mx-auto my-12  border-8 border-white ' src={PriceList} alt="" />
                    </div> */}

          <Accordions
            header="רשימת השירותים בסטודיו"
            listItems={[
              'פגישת ייעוץ מותאמת אישית',
              'שיפוץ חכם - מייעוץ עד ביצוע מושלם',
              'עיצוב משרדים ומרחבי חינוך: יצירת סביבה מעוררת השראה',
              'תכנון ועיצוב דירות קבלן',
              'דירות בתהליכי תמא',
              'הום סטיילינג',
              'שילוב נגישות',
            ]}
            headerContact="תקשורת ושעות פעילות"
            phoneNumber="+972528798447"
            email="d@dafnac.co.il"
            activityHours={[
              { text: "ימים א' - ה'", hours: '09:00 - 17:00' },
              // { text: "יום ו'", hours: '09:00 - 17:00' },
            ]}
            placeText="ירושלים, מעצבת פרויקטים ברחבי הארץ"
            placeUrl="https://maps.app.goo.gl/Wm8Gy6krPUH4T8dJ9"
            type="rounded"
          />
        </div>

        <div style={divStyle}>
          <ImageSwiperCloser type="top" images={images} />
          <ImageSwiper images={images} type="rounded" />
          <ImageSwiperCloser type="bottom" images={images} />
          {/* <div style={divStyle}> */}

          {/* </div> */}
          {/* <ProductsSwiper products={pilatesProducts} title="כל מה שאצלנו בקליניקה" subtitle="" /> */}

          <Title text="לקוחות ממליצים" />
          <div style={divStyle}>
            <ClientsSwiper
              testimonials={[
                {
                  text: 'פנינו אצל המעצבת דפנה כהן על מנת לשפץ את הדירה החדשה שרכשנו. דפנה היתה קשובה לרצונות ולחלומות שלנו. וניהלה את כל תהליך השיפוץ מול אנשי הביצוע בצורה מקצועית ובטוחה, מה שאפשר לנו להמשיך  בסדר היום העמוס שלנו ולהגיע לדירה המשופצת בצורה הכי רגועה. קבלנו הדירה יפה וכל בני המשפחה נהנים מאוד להיות בבית חדש ונעים.',
                  author: 'ד"ר י. לוי',
                },
                {
                  text: 'קנינו דירה חדשה מקבלן ולא ידענו כיצד להתאימה למשפחה שלנו. הגענו לדפנה ובזכות הידע שלה קיבלנו דירה מתוכננת במדויק. הצלחנו להכניס בשטח הנתון כל כך הרבה דברים שלא האמנו שיכנסו לדירה. התכנון המקצועי והמבריק שלה פשוט הפך את הדירה לדירה מושלמת עבורינו. תודה דפנה.',
                  author: 'ד. אופק',
                },
                {
                  text: 'בנינו בית חדש והתלבטנו בין כמה מעצבות מי הכי תתאים לעבוד עם האדריכל שלנו בתכנון ועיצוב הפנים. מהפגישה הראשונה עם דפנה קיבלנו הרגשה נפלאה ובטוחה. דפנה הקשיבה לכל הצרכים שהעלנו בפניה, הבינה מיד את כל התמונה, מצאה פתרונות מדויקים עבורינו ועבדה בקשר הדוק ומקצועי עם האדריכל עד לקבלת התוצאה המושלמת עבורינו. אנחנו מאוד ממליצים לעבוד עם דפנה.',
                  author: 'א. מזרחי',
                },
                {
                  text: 'ברצוני להמליץ על השירות המקצועי של המעצבת דפנה כהן. התחלנו את תהליך השיפוץ עם הרבה חששות וחוסר ידע, וכשדפנה נכנסה לתמונה הרגשנו שאנחנו בידיים הכי נכונות. כל תהליך השיפוץ התנהל בצורה מקצועית ורוגעה, דפנה היתה זמינה לכל שאלה וסיימנו את הכל בדיוק בזמן שנקבע. נכנסנו לבית יפה ומתוכנן בצורה חכמה ביותר עבורינו. תודה גדולה.',
                  author: 'ש. שטרן',
                },
                {
                  text: 'תודה לך דפנה על שעזרת לנו בבית הספר בעיצוב חדר ישיבות וכיתות לימוד. עזרת לנו לבחור חומרים פרקטים לאורך זמן ולעמוד במסגרת התקציב הנתון. העבודה איתך היתה באווירה נעימה ומקצועית. אנשי הצוות והתלמידים מאוד נהנים ללמוד ולעבוד בחללים היפים שעצבת עבורם. אנחנו ממליצים מאוד לעבוד עם המעצבת דפנה כהן. הרווח יהיה כולו שלכם.',
                  author: 'ר. ברקוביץ',
                },
              ]}
            />

            {/* <Line /> */}

            {/* <div data-aos="fade-zoom-in" data-aos-easing="linear" data-aos-duration="500" data-aos-delay="800">
                        <h1 dir='rtl' className='text-center px-6 max-w-[600px] mx-auto'>
                            שלום לכם לקוחות יקרים! התחלתי לעבוד עם שירות לקביעת תורים, מעכשיו תוכלו להזמין אצלי תורים בפשטות ובקלות. הורידו את האפליקציה בכפתור למטה, הירשמו וחפשו לפי קוד העסק:
                            <br />
                            <span className='font-bold'> 25670</span>
                        </h1>

                    </div> */}

            <div data-aos="fade-down" data-aos-easing="ease-in-out">
              <Line />

              <CallToAction
                header="לייעוץ ופרטים נוספים לחצו על הלוגו"
                phoneNumber="+972528798447"
                contact="whatsapp"
                type="noBg"
                image={LogoReal}
              />

              <Line />
            </div>

            <Share type="circleBorder" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default HomePage
